export default {
    institution_role: 2,
    economy_view_role: 3,
    institution_view_role: 4
}